import React from "react";
import { IRateAppointment } from "../interface/iRateAppointment";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { endpoints } from "../../../../endpoints/endpoints";
import { IRating } from "../../appointments/interface/iRating";
import { User, AppContext } from "../../../../context/appContext";
import { AppointmentsParticipantContext } from "../../appointments/context/appointmentsParticipantContext";

export const RateAppointmentContext = React.createContext<any>({});

const RateAppointmentProvider = ({ children }: any): React.JSX.Element => {
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const {
    rating,
    setRating,
    loadAppointments,
  }: {
    rating: IRating;
    setRating: React.Dispatch<React.SetStateAction<IRating>>;
    loadAppointments: () => void;
  } = React.useContext(AppointmentsParticipantContext);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [rateAppointmentDto, setRateAppointmentDto] =
    React.useState<IRateAppointment>({
      starQestions: [
        {
          rating: 0,
          text: "Der Coach gestaltete unsere Zusammenarbeit wertschätzend und professionell *",
        },
        {
          rating: 0,
          text: "Im Coaching konnte ich meine offenen Fragen klären *",
        },
        {
          rating: 0,
          text: "Durch das Coaching fühle ich mich im Bewerbungsprozess sicherer *",
        },
        {
          rating: 0,
          text: "Durch das Coaching bin ich mir meiner Kompetenzen und Stärken bewusster geworden *",
        },
        {
          rating: 0,
          text: "Durch das Coaching konnte ich zielorientierte Bewerbungsunterlagen erstellen *",
        },
        {
          rating: 0,
          text: "Ich würde das Onlinebewerbungscoaching weiterempfehlen *",
        },
      ],
      speakWithCoachQuestions: [
        {
          checked: false,
          text: "Allgemeiner Bewerbungsprozess",
        },
        {
          checked: false,
          text: "Stellensuche / Nutzung von Onlinestellenbörsen",
        },
        {
          checked: false,
          text: "Lebenslauf",
        },
        {
          checked: false,
          text: "CV Parsing",
        },
        {
          checked: false,
          text: "Anschreiben",
        },
        {
          checked: false,
          text: "Vorstellungsgespräch",
        },
        {
          checked: false,
          text: "Selbstvorstellung",
        },
        {
          checked: false,
          text: "Stärken und Schwächen",
        },
        {
          checked: false,
          text: "Berufliche Umorientierung",
        },
        {
          checked: false,
          text: "Umgang mit Anlagen / Arbeitszeugnissen etc.",
        },
        {
          checked: false,
          text: "Social Media Auftritt",
        },
        {
          checked: false,
          text: "Praktikumssuche",
        },
        {
          checked: false,
          text: "Praktikumsbewerbung",
        },
        {
          checked: false,
          text: "Sonstiges",
        },
      ],
      additionalQuestions: [
        {
          section: "Bewerbungsunterlagen & Prozesse",
          questions: [
            {
              checked: false,
              text: "Ungewöhnliche Bewerbungsformate (Flyer / Kurzbewerbung / Video etc.)",
            },
            {
              checked: false,
              text: "Initiativbewerbung zielorientiert gestalten",
            },
            {
              checked: false,
              text: "Online-Bewerbungsportale auf Unternehmensseiten",
            },
            {
              checked: false,
              text: "Nutzung von KI im Bewerbungsprozess",
            },
            {
              checked: false,
              text: "Arbeitszeugnisse – Formales & Formulierungen",
            },
            {
              checked: false,
              text: "Gestaltung von Arbeitsverträgen",
            },
          ],
        },
        {
          section: "Digitale Bewerbung & Netzwerke",
          questions: [
            {
              checked: false,
              text: "Social Media / LinkedIn & Co.",
            },
            {
              checked: false,
              text: "Digitale Präsenz und Personal Branding",
            },
            {
              checked: false,
              text: "Bewerbungshomepage oder digitales Portfolio",
            },
            {
              checked: false,
              text: "Mediengestützte Interviews (Teams / Skype etc.)",
            },
            {
              checked: false,
              text: "Bewerbung per App und Mobile Recruiting",
            },
          ],
        },
        {
          section: "Bewerbungsgespräche & Auswahlverfahren",
          questions: [
            {
              checked: false,
              text: "Vorbereitung auf Vorstellungsgespräche",
            },
            {
              checked: false,
              text: "Assessment Center souverän meistern",
            },
            {
              checked: false,
              text: "Kontakt zu Headhuntern aufbauen",
            },
            {
              checked: false,
              text: "Jobmessen & Unternehmensveranstaltungen nutzen",
            },
            {
              checked: false,
              text: "Gehaltsverhandlung strategisch führen",
            },
          ],
        },
        {
          section: "Persönliche und soziale Themen",
          questions: [
            {
              checked: false,
              text: "Selbstbewusst auftreten und sich präsentieren",
            },
            {
              checked: false,
              text: "Soft Skills und kulturelle Passung zeigen",
            },
            {
              checked: false,
              text: "Umgang mit Stress und Bewerbungsfrust",
            },
            {
              checked: false,
              text: "Work-Life-Balance im neuen Job",
            },
            {
              checked: false,
              text: "Die ersten 100 Tage im neuen Job gut gestalte",
            },
          ],
        },
        {
          section: "Besondere Lebenslagen",
          questions: [
            {
              checked: false,
              text: "Bewerbung mit Migrationshintergrund",
            },
            {
              checked: false,
              text: "Bewerbung im Ausland (z.B. UK / USA)",
            },
            {
              checked: false,
              text: "Umgang mit Behinderung",
            },
            {
              checked: false,
              text: "Umgang mit Neurodivergenz (z.B. ADHS / Autismus)",
            },
            {
              checked: false,
              text: "Bewerbung 50plus",
            },
          ],
        },
        {
          section: "Orientierung & Zielklärung",
          questions: [
            {
              checked: false,
              text: "Berufliche Zielsetzung nach Qualifizierung",
            },
            {
              checked: false,
              text: "Stärkenanalyse und Kompetenzprofil erstellen",
            },
            {
              checked: false,
              text: "Neuorientierung nach längerer Pause (z.B. Elternzeit / Krankheit)",
            },
          ],
        },
      ],
      personalFeedback: "",
      freeText: "",
    });

  const handleSubmit = React.useCallback((): void => {
    // formatting the DTO to send to the backend
    // the database structure ist old and the new DTO dosnt match the old one
    // so we need to format the DTO to match the old one
    const formattedDTO = {
      sessionId: user.sessionId,
      appointmentId: rating.appointment.id,
      starQestions: rateAppointmentDto.starQestions.map(
        (question) => question.rating
      ),
      personalFeedback: rateAppointmentDto.personalFeedback,
      freeText: rateAppointmentDto.freeText,
      // create a string of all texts of speakWithCoach who are checked seperated by ","
      speakWithCoachQuestions: rateAppointmentDto.speakWithCoachQuestions
        .filter((question) => question.checked)
        .map((question) => question.text)
        .join(", "),
      // create a string of all texts of rateViaOtherChannels who are checked seperated by ","
      additionalQuestions: rateAppointmentDto.additionalQuestions
        .flatMap((question) => question.questions)
        .filter((question) => question.checked)
        .map((question) => question.text)
        .join(", "),
    };

    axios
      .post(endpoints.participant.rateCoaching, formattedDTO)
      .then((response) => {
        checkSession(response);

        if (response.data.status === "error") {
          enqueueSnackbar(
            "Fehler beim Senden der Bewertung. Bitte versuchen Sie es später erneut.",
            {
              variant: "error",
            }
          );
          return;
        }

        enqueueSnackbar("Bewertung erfolgreich gesendet", {
          variant: "success",
        });

        loadAppointments();

        setRating({
          open: false,
          appointment: {} as IRating["appointment"],
        });
      })
      .catch((error) => {
        console.error("Error fetching coach list", error);
        enqueueSnackbar(
          "Fehler beim Senden der Bewertung. Bitte versuchen Sie es später erneut.",
          {
            variant: "error",
          }
        );
      });

    console.log("Formatted DTO:", formattedDTO);
  }, [
    checkSession,
    loadAppointments,
    rateAppointmentDto.additionalQuestions,
    rateAppointmentDto.freeText,
    rateAppointmentDto.personalFeedback,
    rateAppointmentDto.speakWithCoachQuestions,
    rateAppointmentDto.starQestions,
    rating.appointment.id,
    setRating,
    user.sessionId,
  ]);

  const value: {} = React.useMemo(
    () => ({
      rateAppointmentDto,
      setRateAppointmentDto,
      isLoading,
      setIsLoading,
      handleSubmit,
    }),
    [handleSubmit, isLoading, rateAppointmentDto]
  );

  return (
    <RateAppointmentContext.Provider value={value}>
      {children}
    </RateAppointmentContext.Provider>
  );
};

export default RateAppointmentProvider;
